import cn, { clsx } from 'clsx';
import { RadioButtonProps } from 'common/types/types';

import styles from './styles';

const RadioButton = ({
  name,
  value,
  checked,
  theme = 'default',
  label,
  placeholder,
  invalid,
  onChange,
  stylesConfig,
  disabled,
  rightAligned = false
}: RadioButtonProps) => {
  const inputClassName = cn(styles[theme].input, invalid && styles[theme].error);
  // This id is for attaching a label to the input. 
  // We make it unique so that there are no problems with an array of elements
  const uniqueId = `${name}-${value}`;

  return (
    <label
      htmlFor={uniqueId}
      className={cn(
        rightAligned ? clsx(styles[theme].container, 'justify-between') : styles[theme].container,
        checked ? styles[theme].selected : styles[theme].unselected // Apply selected/unselected styles
      )}
    >
      {rightAligned ? (
        <>
          <span className={styles[theme].label}>{label}</span>
          <input
            id={uniqueId}
            name={name}
            type="radio"
            placeholder={placeholder}
            className={cn(inputClassName)}
            onChange={onChange}
            value={value}
            checked={checked}
            autoComplete="off"
            style={stylesConfig?.inputStyle}
            disabled={disabled}
          />
        </>
      ) : (
        <>
          <input
            id={uniqueId}
            name={name}
            type="radio"
            placeholder={placeholder}
            className={cn(inputClassName)}
            onChange={onChange}
            value={value}
            checked={checked}
            autoComplete="off"
            style={stylesConfig?.inputStyle}
            disabled={disabled}
          />
          <span className={styles[theme].label}>{label}</span>
        </>
      )}
    </label>
  );
};

export { RadioButton };
